import { render, staticRenderFns } from "./MealPlanFreeCard.vue?vue&type=template&id=ce22740a&scoped=true&"
import script from "./MealPlanFreeCard.vue?vue&type=script&lang=js&"
export * from "./MealPlanFreeCard.vue?vue&type=script&lang=js&"
import style0 from "./MealPlanFreeCard.vue?vue&type=style&index=0&id=ce22740a&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ce22740a",
  null
  
)

export default component.exports